import { ShieldCheck } from "lucide-react"

const tiers = [
  {
    no: 1,
    range: "$1,000 – $2,999.99 USD",
    rangeSub: "(o su equivalente en MXN)",
    color: "#f0b429",
    bg: "rgba(240,180,41,0.08)",
    border: "rgba(240,180,41,0.35)",
    action: "INE/IFE vigente + registro de datos en el sistema automatizado.",
    detail: null,
  },
  {
    no: 2,
    range: "$3,000 – $4,999.99 USD",
    rangeSub: "(o su equivalente en MXN)",
    color: "#e07b2a",
    bg: "rgba(224,123,42,0.08)",
    border: "rgba(224,123,42,0.35)",
    action: "INE/IFE vigente + registro en sistema automatizado + copia de identificación.",
    detail: "La copia debe incluir: Número de identificación, número de teléfono y ocupación.",
  },
  {
    no: 3,
    range: "$5,000 USD o más",
    rangeSub: "(o su equivalente en MXN)",
    color: "#c0392b",
    bg: "rgba(192,57,43,0.08)",
    border: "rgba(192,57,43,0.35)",
    action: "INE/IFE vigente + registro en sistema + Declaración Firmada de la persona física + documentación según Tipo de Usuario.",
    detail: null,
  },
]

export default function RequirementsSection() {
  return (
    <section id="requisitos-section" className="py-16 px-4" style={{ background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)" }}>
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-3">
            <ShieldCheck style={{ color: "#c0392b", width: 32, height: 32 }} />
            <h2 className="text-3xl font-bold" style={{ color: "#1a1a1a" }}>
              Documentos Requeridos
            </h2>
          </div>
          <p className="text-gray-500 max-w-xl mx-auto text-sm">
            De acuerdo con la regulación vigente de la CNBV, los requisitos varían según el monto de la operación.
          </p>
        </div>

        {/* INE banner */}
        <div style={{
          display: "flex", alignItems: "center", gap: 12,
          background: "rgba(198,43,43,0.06)", border: "1px solid rgba(198,43,43,0.2)",
          borderRadius: 12, padding: "12px 20px", marginBottom: 28, maxWidth: 560, margin: "0 auto 28px"
        }}>
          <span style={{ fontSize: 22 }}>🪪</span>
          <p style={{ margin: 0, fontSize: 14, color: "#333" }}>
            <strong style={{ color: "#c0392b" }}>Todos los niveles requieren INE/IFE vigente</strong> como documento base de identificación.
          </p>
        </div>


        {/* Table — desktop */}
        <div className="hidden md:block rounded-2xl overflow-hidden shadow-xl border border-gray-100">
          <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff" }}>
            <thead>
              <tr style={{ background: "#c0392b" }}>
                <th style={{ color: "#fff", padding: "14px 20px", textAlign: "center", fontWeight: 700, fontSize: 14, width: 60 }}>No.</th>
                <th style={{ color: "#fff", padding: "14px 20px", textAlign: "left", fontWeight: 700, fontSize: 14 }}>Importe de la Operación</th>
                <th style={{ color: "#fff", padding: "14px 20px", textAlign: "left", fontWeight: 700, fontSize: 14 }}>Acción para Identificar al Usuario</th>
              </tr>
            </thead>
            <tbody>
              {tiers.map((tier, i) => (
                <tr
                  key={tier.no}
                  style={{
                    background: i % 2 === 0 ? "#fff" : "#fafafa",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <td style={{ padding: "18px 20px", textAlign: "center" }}>
                    <span style={{
                      display: "inline-flex", alignItems: "center", justifyContent: "center",
                      width: 32, height: 32, borderRadius: "50%",
                      background: tier.color, color: "#fff",
                      fontWeight: 800, fontSize: 15
                    }}>{tier.no}</span>
                  </td>
                  <td style={{ padding: "18px 20px", verticalAlign: "top" }}>
                    <div style={{ fontWeight: 700, color: tier.color, fontSize: 15 }}>{tier.range}</div>
                    <div style={{ color: "#888", fontSize: 12, marginTop: 2 }}>{tier.rangeSub}</div>
                  </td>
                  <td style={{ padding: "18px 20px", verticalAlign: "top" }}>
                    <p style={{ color: "#333", fontSize: 14, margin: 0 }}>{tier.action}</p>
                    {tier.detail && (
                      <p style={{
                        color: "#666", fontSize: 12, marginTop: 8,
                        padding: "8px 12px", borderRadius: 8,
                        background: tier.bg, borderLeft: `3px solid ${tier.color}`
                      }}>
                        📌 {tier.detail}
                      </p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards — mobile */}
        <div className="md:hidden flex flex-col gap-4">
          {tiers.map((tier) => (
            <div
              key={tier.no}
              style={{
                background: "#fff",
                borderRadius: 16,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                border: `1px solid ${tier.border}`,
                overflow: "hidden"
              }}
            >
              <div style={{ background: tier.color, padding: "12px 16px", display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  width: 28, height: 28, borderRadius: "50%",
                  background: "rgba(255,255,255,0.25)", color: "#fff", fontWeight: 800, fontSize: 14
                }}>{tier.no}</span>
                <div>
                  <div style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>{tier.range}</div>
                  <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 11 }}>{tier.rangeSub}</div>
                </div>
              </div>
              <div style={{ padding: "14px 16px" }}>
                <p style={{ color: "#333", fontSize: 14, margin: 0 }}>{tier.action}</p>
                {tier.detail && (
                  <p style={{
                    color: "#666", fontSize: 12, marginTop: 10,
                    padding: "8px 12px", borderRadius: 8,
                    background: tier.bg, borderLeft: `3px solid ${tier.color}`
                  }}>
                    📌 {tier.detail}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 mt-8">
          Regulación conforme a las disposiciones emitidas por la CNBV. Sujeto a cambios sin previo aviso.
        </p>
      </div>
    </section>
  )
}
